import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { NotificationService } from '../notification.service';
import { ClaimService } from 'src/app/claims/claim.service';
import { AlertService } from 'src/app/shared/toast/alert.service';
import { SELECT_ITEM_HEIGHT_EM } from '@angular/material/select';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent implements OnInit {
  title = "Notification"
  loggedInUser: any;

  constructor(private activatedRoute: ActivatedRoute
    , private loadingService: CustomLoadingService
    , private notificationService: NotificationService
    , private claimService: ClaimService
    , private appSettingService: AppSettingService
    , private router: Router
    , private translateService: TranslateService
    , private alertService: AlertService
    ) { 

      
    this.appSettingService.profileDetail.subscribe(res => {
      this.appSettingService.loggedInUser = res;
      this.loggedInUser = this.appSettingService.loggedInUser;
    });

    this.loggedInUser = this.appSettingService.loggedInUser;
    
  }

  activeNotifications: any = [];
  pastNotifications: any = [];
  pagePhrase: string;    

  ngOnInit(): void {

    // this.loggedInUser.UnreadNotifications = 1;// <number>(this.loggedInUser.UnreadNotifications) + 1;
    // this.appSettingService.loggedInUser = this.loggedInUser;

    this.getNotification();
    this.UpdateNotificationViewStatus();
  }

  getNotification() {
    
    this.loadingService.show();
    this.notificationService.getNotifications().subscribe((res: any) => {
      this.activeNotifications = res.ActiveNotifications;
      this.pastNotifications = res.PastNotifications;
      this.pagePhrase = res.Messages
    }, () => {
      this.loadingService.hide();

    }, () => {
      this.loadingService.hide();
    })
  }


  UpdateNotificationViewStatus(){
    
    this.loadingService.show();
    this.notificationService.UpdateNotificationViewStatus().subscribe((res: any) => {
    }, () => {
      this.loadingService.hide();

    }, () => {
      if (parseInt(this.loggedInUser.UnreadNotifications) > 0){
        this.loggedInUser.UnreadNotifications =0;
        this.appSettingService.loggedInUser = this.loggedInUser;
        location.reload();
      }
      this.loadingService.hide();
      
    })
  }

  public claimUri: string = "/claims"

  clickAcknowledge(item){
    
    this.loadingService.show();
    this.notificationService.AcknowledgeNotification(item).subscribe((res: any) => {
      item.ProviderAcknowledgementStatus = 'Acknowledgement sent';
    
      this.alertService.success(this.translateService.instant("AcknowledgementSent"), { keepAfterRouteChange: true })


    this.loggedInUser.AcknowledgeNotificationsCount = this.loggedInUser.AcknowledgeNotificationsCount - 1;
    this.appSettingService.loggedInUser = this.loggedInUser;

    this.router.navigate([this.claimUri]);


    }, () => {
      this.loadingService.hide();

    }, () => {
      this.loadingService.hide();
    })
  }

}
